import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';

export function ImportadorProductos() {
  return (
    <div>
      <PageHeader
        title="Importador de productos (proveedor)"
        subtitle="Carga masiva del catálogo recibido del fabricante — sección pendiente."
      />
      <Card>
        <p className="text-sm text-slate-600">
          Aquí vivirá el importador masivo del catálogo del proveedor:
          subir Excel con referencias (ref_proveedor, nombre, coste USD,
          MOQ, lead time, especificaciones) y mapear contra la tabla
          productos_proveedor con idempotencia por (proveedor_id,
          ref_proveedor).
        </p>
      </Card>
    </div>
  );
}
